export interface NotFoundObjectError {
  entityId: number;
  entityName: string;
  errorMessage: string;
}

export interface ServerError {
  uid: string;
  message: string;
  stackTrace: string;
  innerException?: Error;
}

export interface ValidationErrorModel {
  message: string;
  instance: string;
  details: ValidationError[];
}

export interface ValidationError {
  target: string;
  severity: ValidationErrorSeverity;
  code: string;
  placeholders: object;
  message?: string | null;
  payload?: any | null;
}

type ValidationErrorSeverity = 'error' | 'warning';

export enum ErrorType {
  UnAuthorizedError,
  NotFoundError,
  ValidationError,
  InternalServerError,
}

export interface ErrorState {
  [key: string]: ValidationError[];
}
